export const fileCarouselHintContainerId = "file-carousel-hint-container";
export const useGetFileCarouselHintPortalElement = () => {
    return document.getElementById(fileCarouselHintContainerId);
};
